"use client";

import React from "react";
import { SDialogFC, SDialogProps } from "@/Master/SDialogFC/SDialogFC";
import styles from "./shortcut.module.css";

interface ShortcutDialogProps extends SDialogProps {}

export const ShortcutDialogFC: React.FC<ShortcutDialogProps> = (props) => {
    const { fcKey, isOpen, onClose } = props;

    if (!isOpen) return null;

    return (
        <SDialogFC
            fcKey={fcKey}
            isOpen={isOpen}
            mode="Center"
            title=""
            buttons={[
                { label: "Add Now", onClick: () => console.log(1111), style: "greenBtn" },
            ]}
            onClose={onClose}
        >
            <div className={styles.container}>
                <img className={`${styles.money} ${styles.money1}`} src="/img/shortcut/$_3.webp" alt="Money" />
                <img className={styles.phone} src="/img/shortcut/ico_addtohome.webp" alt="Phone" />
                <img className={styles.circle} src="/img/shortcut/icon.webp" alt="Circle Icon" />
                <img className={`${styles.money} ${styles.money2}`} src="/img/shortcut/$_2.webp" alt="Money" />
                <p>It's so easy! Just add to the home screen! Shortcut to receive!</p>
                <div className={styles.sc_free}>
                    <img className={styles.gold} src="/img/ico_sc.png" alt="Gold Icon" />
                    2 SC FREE
                </div>
            </div>
        </SDialogFC>
    );
};
